/* eslint-disable @typescript-eslint/no-explicit-any */
export function useEpiInit(dataFetchFn: () => Promise<void>): void {
  const { query } = useRoute();

  const { liveEditState } = useLiveEdit(query.epieditmode === 'True');

  function setLiveEdit(): void {
    liveEditState.value.inEditMode = (window as any).epi.inEditMode;
    liveEditState.value.isEditable = (window as any).epi.isEditable;
  }

  onMounted(() => {
    if (!(window as any).epi) return;

    // Check that ready is an actual true value (not just truthy).
    if ((window as any).epi.ready === true) {
      setLiveEdit();
    }

    if ((window as any).epi?.subscribe) {
      // Subscribe if the `epiReady` event hasn't happened yet.
      (window as any).epi.subscribe('epiReady', () => {
        setLiveEdit();
      });

      (window as any).epi.subscribe('contentSaved', async () => {
        await dataFetchFn();
      });
    }
  });
}
